import React from 'react';
import gomi from '../assets/bears/gomi.svg';
import bongbong from '../assets/bears/bongbong.svg';
import kongi from '../assets/bears/kongi.svg';
import nuri from '../assets/bears/nuri.svg';
import bandal from '../assets/bears/bandal.svg';
import kongiDashboard from '../assets/bears/kongi-dashboard.svg';

// The Bear Patrol (the storyboard): one head for each part of the system. Where each one stands is decided here and in navConfig, nowhere else:
//   gomi      the agent on every computer      Devices
//   bongbong  the messenger, jobs and results  Actions
//   kongi     the librarian, software and the catalogue   the Add software blades, the Software tab
//   nuri      the rule keeper                  Policies
//   bandal    the security guard               Findings
export const BEARS = { gomi, bongbong, kongi, nuri, bandal, kongiDashboard };    // kongiDashboard: Kongi with the dashboard's chart, the menu icon of the Dashboard
export const PATROL = ['gomi', 'bongbong', 'kongi', 'nuri', 'bandal'];

// A head, drawn for company rather than for information: the words next to it say the same, so it has no alternative text.
export default function Bear({ name, size = 40, className = '', onClick }) {
  if (!BEARS[name]) return null;
  return <img className={`bear-head ${className}`.trim()} src={BEARS[name]} alt="" aria-hidden="true" width={size} height={size} onClick={onClick} />;
}

// All five in a row, for the places that stand for the whole system (the dashboard, the sign-in).
export function Patrol({ size = 44 }) {
  return <span className="patrol" aria-hidden="true">{PATROL.map((n) => <Bear key={n} name={n} size={size} />)}</span>;
}
